export default __webpack_public_path__ + "assets/images/find_storage_top_image_laBt-.jpg";